module.exports = __webpack_public_path__ + "static/media/ABOUT3.339e3755.jpg";